































































import Vue from 'vue';
import VariableInput from '@/components/util/VariableInput.vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { checkUserId } from '@/api/Login';
import { getCorporateUserRegisterData, createCorporateUser } from "@/api/Corporation";
import { CorporateUserRegisterData } from "@/api/dto/Corporation";
import {
  nicknameRegExp,
  nicknameaLengthLimit,
  nicknameErrorMessage,
  passwordConstraintMessage,
  passwordConstraintErrorMessage, 
  passwordRegExp, 
  userIdConstraintMessage,
  userIdConstraintErrorMessage, 
  userIdRegExp,
} from './constraint';

export default Vue.extend({
  name: 'CorporateUserValidate',
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    /**
     * 入力値変更時にバリデーション
     */
    'inputUserId'(userId: string) {
      this.signupInputs['userId'].ok = '';
      this.signupInputs['userId'].error = userIdRegExp.test(userId) ? '' : userIdConstraintErrorMessage;
      this.checkUserId(userId);
    },
    'inputNickname'(nickname: string) {
      this.signupInputs['nickname'].error = nicknameRegExp.test(nickname) && nickname.length <= nicknameaLengthLimit
        ? '' : nicknameErrorMessage;
    },
    'inputPassword'(password: string) {
      this.signupInputs['password'].error = passwordRegExp.test(password) ? '' : passwordConstraintErrorMessage;
    },
  },
  data() {
    return {
      inputUserId: '',
      inputNickname: '',
      inputPassword: '',
      companyUserRegisterData: {} as CorporateUserRegisterData,
      signupInputs: {
        userId: { name: 'ユーザーID', type: 'text', placeholder: 'ID', constraint: userIdConstraintMessage, error: '', ok: '' },
        nickname: { name: '表示名', type: 'text', placeholder: '表示名', constraint: nicknameErrorMessage, error: '', ok: '' },
        password: { name: 'パスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: 'パスワード', error: '' },
      },
      isSubmit: false,
      isAvailableId: true,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 表示用情報取得
      const res = await getCorporateUserRegisterData(to.params.id);
      next(vm => {
        vm.$data.companyUserRegisterData = res;
      });
    } catch (e) {
      // APIエラー
      next({ name: "Top" });
    }
  },
  created() {
    this.$store.dispatch("logout");
  },
  methods: {
    /**
     * ユーザーID重複チェックをし, それに応じたメッセージを設定する
     */
    async checkUserId(userId: string) {
      if (!userIdRegExp.test(userId)) {
        return;
      }
      const res = await checkUserId({ userId });
      this.isAvailableId = res.isAvailable;
      if (res.isAvailable) {
        this.signupInputs['userId'].error = '';
        this.signupInputs['userId'].ok = res.message;
      } else {
        this.signupInputs['userId'].error = res.message;
      }
    },
    async onClickSignUp() {
      try {
        await createCorporateUser({
          mailAddress: this.companyUserRegisterData.mailAddress,
          userId: this.inputUserId,
          nickname: this.inputNickname,
          password: this.inputPassword,
        });
      } catch (error) {
        this.isSubmit = false;
        this.$emit('errorToast', '登録に失敗しました');
      }
      this.isSubmit = true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  }
})
